// Libs
import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';

// Components
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

// Utils
import useTranslator from 'UTILS/hooks/useTranslator';
import { navigatorDetails } from 'UTILS/navigator';
import { NARROW_LAYOUT } from 'UTILS/constants';
import { CHECK_TRANSLATION_MAP } from 'CHECKS/index';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';

const Support = ({
  onClose = () => {},
  open = false,
  hintList = [],
  title = '',
  data = {},
  checkLabel,
}) => {
  const theme = useTheme();
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const [translateResults] = useTranslator(CHECK_TRANSLATION_MAP[checkLabel]);
  const bgColorTheme = theme.palette.background.paper;

  return (
    <Drawer open={open} onClose={onClose} anchor='right'>
      <Box bgcolor={bgColorTheme} className={isSmallScreen ? 'support-container' : 'support-container_partScreen'}>
        <Box className='support-button' >
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </Box>
        <Box className='support-title' ><Typography variant='h5' >{translateResults(title, { ...data, ...navigatorDetails })}</Typography></Box>
        <Box bgcolor={bgColorTheme}>
          {hintList.map((hint) => {
            const Icon = hint.icon;
            return (
              <Box className='support-messageContainer' key={hint.title}>
                <Icon className='support-icon' />
                <Typography variant='h6' >
                  <Box component='span' className='support-subtitle'>{translateResults(hint.title, { ...data, ...navigatorDetails })}</Box>
                </Typography>
                <Typography color='textSecondary' variant='body2' >
                  <Box component='span'> {translateResults(hint.text, { ...data, ...navigatorDetails })}</Box>
                </Typography>
                {hint.buttonList?.length > 0 && (
                  <Box className='support-buttonContainer'>
                    { hint.buttonList.map(({ href, self, label }) => {
                      if (href) {
                        return (
                          <Box marginRight='10px' key={label}>
                            <Button
                              size='small'
                              color='primary'
                              variant='text'
                              href={translateResults(href)}
                              target={self ? '_self' : '_blank'}
                            >
                              {translateResults(label)}
                            </Button>
                          </Box>
                        );
                      }
                    })}
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Drawer>
  );
};

export default Support;
